// extracted by mini-css-extract-plugin
export default {"icon":"icon___AlOeP","filled":"filled___UaNT2"};